/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/pipeline.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleRpcStatus } from './GoogleRpcStatus';
import {
  GoogleRpcStatusFromJSON,
  GoogleRpcStatusFromJSONTyped,
  GoogleRpcStatusToJSON,
  GoogleRpcStatusToJSONTyped,
} from './GoogleRpcStatus';
import type { V2beta1Url } from './V2beta1Url';
import {
  V2beta1UrlFromJSON,
  V2beta1UrlFromJSONTyped,
  V2beta1UrlToJSON,
  V2beta1UrlToJSONTyped,
} from './V2beta1Url';

/**
 * Required input. Pipeline version object with updated fields.
 * pipeline_id and pipeline_version_id are required to identify the version.
 * Mutable fields: display_name, tags.
 * @export
 * @interface PipelineServiceUpdatePipelineVersionRequest
 */
export interface PipelineServiceUpdatePipelineVersionRequest {
  /**
   * Required if name is not provided. Pipeline version display name provided by user.
   * This is ignored in CreatePipelineAndVersion API.
   * @type {string}
   * @memberof PipelineServiceUpdatePipelineVersionRequest
   */
  display_name?: string;
  /**
   * Required if display_name is not provided. Pipeline version name provided by user.
   * This is ignored in CreatePipelineAndVersion API.
   * @type {string}
   * @memberof PipelineServiceUpdatePipelineVersionRequest
   */
  name?: string;
  /**
   * Optional input field. Short description of the pipeline version.
   * This is ignored in CreatePipelineAndVersion API.
   * @type {string}
   * @memberof PipelineServiceUpdatePipelineVersionRequest
   */
  description?: string;
  /**
   * Output. Creation time of the pipeline version.
   * @type {Date}
   * @memberof PipelineServiceUpdatePipelineVersionRequest
   */
  created_at?: Date;
  /**
   *
   * @type {V2beta1Url}
   * @memberof PipelineServiceUpdatePipelineVersionRequest
   */
  package_url?: V2beta1Url;
  /**
   * Input. Optional. The URL to the code source of the pipeline version.
   * The code is usually the Python definition of the pipeline and potentially
   * related the component definitions. This allows users to trace back to how
   * the pipeline YAML was created.
   * @type {string}
   * @memberof PipelineServiceUpdatePipelineVersionRequest
   */
  code_source_url?: string;
  /**
   * Output. The pipeline spec for the pipeline version.
   * @type {object}
   * @memberof PipelineServiceUpdatePipelineVersionRequest
   */
  pipeline_spec?: object;
  /**
   *
   * @type {GoogleRpcStatus}
   * @memberof PipelineServiceUpdatePipelineVersionRequest
   */
  error?: GoogleRpcStatus;
  /**
   * Optional input field. User-defined tags (key-value pairs) for the pipeline version.
   * Constraints:
   *   - Maximum 20 tags per pipeline version.
   *   - Both keys and values are limited to 63 characters.
   *   - Keys cannot be empty and must not contain the '.' character.
   * Tags are stored in a separate table and can be retrieved via Get and List APIs.
   * @type {{ [key: string]: string; }}
   * @memberof PipelineServiceUpdatePipelineVersionRequest
   */
  tags?: { [key: string]: string };
}

/**
 * Check if a given object implements the PipelineServiceUpdatePipelineVersionRequest interface.
 */
export function instanceOfPipelineServiceUpdatePipelineVersionRequest(
  value: object,
): value is PipelineServiceUpdatePipelineVersionRequest {
  return true;
}

export function PipelineServiceUpdatePipelineVersionRequestFromJSON(
  json: any,
): PipelineServiceUpdatePipelineVersionRequest {
  return PipelineServiceUpdatePipelineVersionRequestFromJSONTyped(json, false);
}

export function PipelineServiceUpdatePipelineVersionRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PipelineServiceUpdatePipelineVersionRequest {
  if (json == null) {
    return json;
  }
  return {
    display_name: json['display_name'] == null ? undefined : json['display_name'],
    name: json['name'] == null ? undefined : json['name'],
    description: json['description'] == null ? undefined : json['description'],
    created_at: json['created_at'] == null ? undefined : new Date(json['created_at']),
    package_url: json['package_url'] == null ? undefined : V2beta1UrlFromJSON(json['package_url']),
    code_source_url: json['code_source_url'] == null ? undefined : json['code_source_url'],
    pipeline_spec: json['pipeline_spec'] == null ? undefined : json['pipeline_spec'],
    error: json['error'] == null ? undefined : GoogleRpcStatusFromJSON(json['error']),
    tags: json['tags'] == null ? undefined : json['tags'],
  };
}

export function PipelineServiceUpdatePipelineVersionRequestToJSON(
  json: any,
): PipelineServiceUpdatePipelineVersionRequest {
  return PipelineServiceUpdatePipelineVersionRequestToJSONTyped(json, false);
}

export function PipelineServiceUpdatePipelineVersionRequestToJSONTyped(
  value?: PipelineServiceUpdatePipelineVersionRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    display_name: value['display_name'],
    name: value['name'],
    description: value['description'],
    created_at:
      value['created_at'] == null ? value['created_at'] : value['created_at'].toISOString(),
    package_url: V2beta1UrlToJSON(value['package_url']),
    code_source_url: value['code_source_url'],
    pipeline_spec: value['pipeline_spec'],
    error: GoogleRpcStatusToJSON(value['error']),
    tags: value['tags'],
  };
}
